
import React, { useState } from 'react'
import AddIcon from "@mui/icons-material/Add";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import statusIcon from "../../../assets/svg/Check icon.svg"
import { Box, Checkbox, Chip, Divider, FormControl, IconButton, InputAdornment, LinearProgress, Link, List, ListItem, Menu, MenuItem, Paper, Popover, Select, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ArrowForward, CloseOutlined, DeleteOutline, EditOutlined, PauseOutlined, People, PlayArrowOutlined } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import CheckIcon from "@mui/icons-material/Check";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { TbSquareRoundedPercentage } from "react-icons/tb";
import { LuUsers } from "react-icons/lu";
import { FaArrowTrendUp } from "react-icons/fa6";
import { MdAccessTime } from "react-icons/md";
import { Area, AreaChart, CartesianGrid, Cell, Line, LineChart, Pie, PieChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { FaGift } from "react-icons/fa6";
import { IoMoonSharp } from "react-icons/io5";
import { IoFlashSharp } from "react-icons/io5";
import { RiOilFill } from "react-icons/ri";
import { IoIosSunny } from "react-icons/io";
import { FaCarBattery } from "react-icons/fa";
import agentimg from "../../../assets/svg/Ellipse 12.svg"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Copy } from 'lucide-react';


const statusColors = {
    Active: {
    bgcolor:"#ECF9F7",
    color:"#3FBEAC"
    },
    Scheduled:{
    bgColor:"#F6E9FC",
    color:"#7E1BAD"
    }, 
    Draft: {
    bgColor:"#F4F8F0",
    color:"#8CB369"
    },
};

function StatusInfoPopover({ anchorEl, onClose, data }) {
    const open = Boolean(anchorEl);

    if (!data) return null;

    const {
        status,
        // activation,
        // activationDate,
        // triggeredBy,
        // note,
    } = data;

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            slotProps={{
                paper: {
                    sx: {
                        width: 260,
                        p: 2,
                        borderRadius: "10px",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.12)",
                    },
                },
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                }}
            >
                <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
                    Status Information
                </Typography>
                <IconButton size="small" onClick={onClose} sx={{ p: 0.3 }}>
                    <CloseIcon sx={{ fontSize: 16 }} />
                </IconButton>
            </Box>

            <Divider sx={{ mb: 1.5 }} />

          <Box sx={{bgcolor: data?.bgColor , p:1, borderRadius:2, my: 1}}>
              {/* Current Status */}
            <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                Current Status
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.7, mb: 1.5 }}>
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        bgcolor: data?.color,
                    }}
                />
                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                    {data?.name}
                </Typography>
            </Box>
          </Box>


            {data?.name === "Active" && 
            <>
              <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                Activation
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                {data?.activate}
            </Typography>

            <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                {data?.status_date}
            </Typography>

    
            <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                Triggered By
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                 {data?.status_by}
            </Typography>
            </>
            
            
            }
            {data?.name === "Scheduled" &&
            <>
              <>
              <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                Start Date
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                {data?.start_date}
            </Typography>

            <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                End Date
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                {data?.end_date}
            </Typography>

    
            <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                Triggered By
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                 {data?.status_by}
            </Typography>
            </>
            
            </>
            
            }
            {data?.name === "Draft" &&
            <>
              <>
              <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                Created By
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                {data?.status_by}
            </Typography>

            <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
                Created Date
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                {data?.status_date}
            </Typography>

    
            <Typography sx={{ fontSize: 11, color: "text.secondary", mb: 0.3 }}>
            Last Edited
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                 {data?.edit_date}
            </Typography>
            </>
            
            </>
            
            }
          

            {/* Note */}
        
                <Box
                    sx={{
                        display: "flex",
                        gap: 0.8,
                        bgcolor: data?.bgColor,
                        borderRadius: "8px",
                        p: 1,
                        alignItems: "flex-start",
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 15, color: data?.color, mt: "1px" }} />
                    <Typography sx={{ fontSize: 11.5, color: "text.secondary", lineHeight: 1.4 }}>
                        {data?.note}
                    </Typography>
                </Box>
            
        </Popover>
    );
}


const IncentivesCoupons = () => {
    const stats = [
        {
            title: "Total Coupons",
            value: 256,
            subtitle: "18% vs last 30 days",
        },
        {
            title: "Active",
            value: 148,
            subtitle: "8% vs last 30 days",
        },
        {
            title: "Scheduled",
            value: 28,
            subtitle: "14% vs last 30 days",
        },
        {
            title: "Draft",
            value: 34,
            subtitle: "In progress",
        },
        {
            title: "Under Review",
            value: 18,
            subtitle: "In review",
        },
        {
            title: "Paused",
            value: 6,
            subtitle: "9% vs last 30 days",
        },
        {
            title: "Expired",
            value: 46,
            subtitle: "-5% vs last 30 days",
        },
        {
            title: "Disabled",
            value: 12,
            subtitle: "9% vs last 30 days",
        }

    ];
    const impact = [
        {
            title: "Total Redemptions",
            value: "45,320",
            subtitle: "15% vs last 30 days",
            icon: <LuUsers />
        },
        {
            title: "Total Discount Given",
            value: "1,245,890 EGP",
            subtitle: "18% vs last 30 days",
            icon: <TbSquareRoundedPercentage />
        },
        {
            title: "Revenue Impact",
            value: "2,845,200 EGP",
            subtitle: "18% vs last 30 days",
            icon: <FaArrowTrendUp />
        },
        {
            title: "Average ROI",
            value: "3.6x",
            subtitle: "9% vs last 30 days",
            icon: <MdAccessTime />
        },


    ];
    const [selectedRows, setSelectedRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedStatusData, setSelectedStatusData] = useState(null);
    const [selectedInfoRows, setSelectedInfoRows] = useState([]);

    const handleStatusInfoOpen = (event, row) => {
        console.log(row);
        
        setAnchorEl(event.currentTarget);
        setSelectedStatusData(row);
    };

    const handleStatusInfoClose = () => {
        setAnchorEl(null);
        setSelectedStatusData(null);
    };

    const columns = [
        {
            field: "id",
            headerName: "ID",
            flex: .6,
            minWidth: 80,
        },

        {
            field: "name",
            headerName: "Coupon Name",
            flex: 1,
            minWidth: 140,
        },
        {
            field: "code",
            headerName: "Code",
            flex: 1,
            minWidth: 140,
        },

        {
            field: "type",
            headerName: "Type",
            flex: 1,
            minWidth: 120,
        },
        {
            field: "priority",
            headerName: "Priority",
            flex: .7,
            minWidth: 90,
            renderCell: (params) => {
                const styles = {
                    High: { bgcolor: "#FFF4F0", color: "#000" },
                    Medium: { bgcolor: "#FFFAEA", color: "#000" },
                    Low: { bgcolor: "#ECF9F7", color: "#000" },
                };
                return (
                    <Chip
                        label={params.row.priority}
                        size="medium"
                        sx={styles[params.row.priority]}
                    />
                );
            },
        },
        {
            field: "trigger",
            headerName: "Trigger",
            flex: 1,
            minWidth: 120,
        },
        {
            field: "fundingSource",
            headerName: "Funding Source",
            flex: 1,
            minWidth: 120,
        },
        {
            field: "budgetUsage",
            headerName: "Budget Usage",
            flex: 1,
            minWidth: 180,
            renderCell: (params) => {
                const getColor = () => {
                    if (params.row.budgetUsage >= 70) return "#3FBEAC";
                    if (params.row.budgetUsage >= 40) return "#FEB91E";
                    return "#A80101";
                };

                return (
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <Box sx={{ width: 100 }}>
                            <Typography>{`${params.row.budgetUsage}%`}</Typography>
                            <LinearProgress
                                variant="determinate"
                                value={params.row.budgetUsage}
                                sx={{
                                    height: 8,
                                    borderRadius: 4,
                                    backgroundColor: "#DADADA",
                                    "& .MuiLinearProgress-bar": {
                                        backgroundColor: getColor(),
                                        borderRadius: 10,
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: "redemptions",
            headerName: "Redemptions",
            flex: 1,
            minWidth: 120,
        },
        {
            field: "risk",
            headerName: "Risk",
            flex: .6,
            minWidth: 90,
            renderCell: (params) => (
                <Chip
                    label={params.row.risk}
                    size="small"
                    sx={{ bgcolor: "#ECF9F7" }}
                />
            ),
        },
        {
            field: "validity",
            headerName: "Validity",
            flex: 1,
            minWidth: 130,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                const styles = {
                    Active: { bgcolor: "#ECF9F7", color: "#000000" },
                    Scheduled: { bgcolor: "#F3E5F5", color: "#000000" },
                    Draft: { bgcolor: "#EEF7E9", color: "#7CB342" },
                };

                return (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" , p:1,}}>
                        <Chip
                            label={params.row.status.name}
                            size="medium"
                            sx={{
                                bgcolor: params.row.status?.bgColor,
                                fontWeight: 500,
                            }}
                        />
                        <IconButton
                            size="small"
                            onClick={(e) => {
                         e.stopPropagation()       
                        handleStatusInfoOpen(e, params.row.status)
                    }}
                        >
                            <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.secondary" }} />
                        </IconButton>
                    </Box>
                );
            },
        },
        {
            field: "lastUpdate",
            headerName: "Last Update",
            flex: 1,
            minWidth: 120,
        },
    {
       field: "actions",
       headerName: "Actions",
       flex: 0.9,
       minWidth: 120,
       sortable: false,
       renderCell: (params) => (
         <>
           
           <IconButton
             disableRipple
             size="small"
             onClick={(e) => {
               handleClick(e, params.row)
               e.stopPropagation();
             }}
           >
             <MoreVertIcon fontSize="small" />
           </IconButton>
           <Menu
             anchorEl={menuState.anchorEl}
             open={Boolean(menuState.anchorEl)}
             onClose={handleClose}
             anchorOrigin={{
               vertical: "bottom",
               horizontal: "right",
             }}
             transformOrigin={{
               vertical: "top",
               horizontal: "right",
             }}
             slotProps={{
               paper: {
                 sx: {
                   borderRadius: 2,
                   p: 2,
                   backgroundColor: "#F9F9F9",
                 },
               },
             }}
           >
               <MenuItem
         
               className="p-1"
               sx={{ display: "flex", gap: 1, borderRadius: 1, color:"#000" }}
             >
               <RemoveRedEyeOutlinedIcon fontSize="small" />
              View Details
             </MenuItem>
               <MenuItem
         
               className="p-1"
               sx={{ display: "flex", gap: 1, borderRadius: 1, color:"#000" }}
             >
               <EditOutlined fontSize="small" />
              Edit
             </MenuItem>
               <MenuItem
         
               className="p-1"
               sx={{ display: "flex", gap: 1, borderRadius: 1, color:"#159D89" }}
             >
               <PlayArrowOutlined fontSize="small" />
              Activate Now
             </MenuItem>
               <MenuItem
         
               className="p-1"
               sx={{ display: "flex", gap: 1, borderRadius: 1, color:"#E6A209" }}
             >
               <PauseOutlined fontSize="small" />
              Pause
             </MenuItem>
                 <MenuItem
         
               className="p-1"
               sx={{ display: "flex", gap: 1, borderRadius: 1, color:"#000" }}
             >
               <Copy size={14}/>
              Duplicate
             </MenuItem>
             <MenuItem
            //    onClick={handleDeleteShow}
               className="p-1"
               sx={{
                 display: "flex",
                 gap: 1,
                 borderRadius: 1,
                 color: "#A80101",
               }}
             >
                <CloseIcon fontSize='small'/>
               Disable
             </MenuItem>
          
           </Menu>
         </>
       ),
     },
    ]

    const rows = [
        {
            id: "CPN-001",
            name: "Welcome 20% off",
            code: "WELCOME20",
            type: "Percentage",
            trigger: "Auto",
            priority: "High",
            fundingSource: "ESTBN",
            risk: "Low",
            validity: "Mar10 - May 31, 2025",
            budgetUsage: 72,
            redemptions: 624,
            status:{
                name: "Active",
                color:"#3FBEAC",
                bgColor: "#ECF9F7",
                note:"This coupon was activated automatically when the start date reached.",
                start_date:null,
                end_date:null,
                status_date:"08 Jul 2026 - 10:00 am",
                edit_date: null,
                status_by:"System Scheduler",
                activate:"Automatic"
            },
      lastUpdate:"2h ago Mona Ali"
        },

        {
            id: "CPN-002",
            name: "Ramadan Special 25",
            code: "RAMADAN25",
            type: "Fixed amount",
            trigger: "Manual",
            priority: "Medium",
            fundingSource: "Provider",
            risk: "Low",
            validity: "Mar10 - May 31, 2025",
            budgetUsage: 58,
            redemptions: 405,
            status:{
                name: "Scheduled",
                color:"#7E1BAD",
                bgColor: "#F6E9FC",
                note:"This coupon is scheduled to be activated on the start date.",
                start_date:"10 Jul 2026 - 12:00 am",
                end_date:"20 Jul 2026 - 11:59 am",
                status_date: null,
                edit_date: null,
                status_by:"System Scheduler",
                activate:null
            },
         lastUpdate:"2h ago Mona Ali"
        },
        {
            id: "CPN-003",
            name: "Flash Sale 50%",
            code: "FLASH50",
            type: "Percentage",
            trigger: "Auto",
            priority: "High",
            fundingSource: "ESTBN",
            risk: "Low",
            validity: "Mar10 - May 31, 2025",
            budgetUsage: 72,
            redemptions: 624,
              status:{
                name: "Active",
                color:"#3FBEAC",
                bgColor: "#ECF9F7",
                note:"This coupon was activated automatically when the start date reached.",
                start_date:null,
                end_date:null,
                status_date:"08 Jul 2026 - 10:00 am",
                edit_date: null,
                status_by:"System Scheduler",
                 activate:"Automatic"
            },
            lastUpdate:"2h ago Mona Ali"
        },

        {
            id: "CPN-004",
            name: "Eid Offer 100",
            code: "EID100",
            type: "Percentage",
            trigger: "Manual",
            priority: "Low",
            fundingSource: "Provider",
            risk: "Low",
            validity: "Mar10 - May 31, 2025",
            budgetUsage: 30,
            redemptions: 405,
              status:{
                name: "Draft",
                color:"#8CB369",
                bgColor:"#F4F8F0",
                note:"This coupon is in draft and not submitted for review yet.",
                start_date:null,
                end_date:null,
                status_date:"07 Jul 2026 - 02:30 pm",
                edit_date:"07 Jul 2026 - 04:30 pm",
                status_by:"Mona Ali",
                activate: null
            },
           lastUpdate:"2h ago Mona Ali"
        },
        {
            id: "CPN-005",
            name: "Eid Offer 200",
            code: "EID100",
            type: "fixed",
            trigger: "Manual",
            priority: "Medium",
            fundingSource: "Provider",
            risk: "Low",
            validity: "Mar10 - May 31, 2025",
            budgetUsage: 50,
            redemptions: 405,
             status:{
                name: "Scheduled",
                color:"#7E1BAD",
                bgColor: "#F6E9FC",
                note:"This coupon is scheduled to be activated on the start date.",
                start_date:"10 Jul 2026 - 12:00 am",
                end_date:"20 Jul 2026 - 11:59 am",
                status_date: null,
                edit_date: null,
                status_by:"System Scheduler",
                activate: null
            },
            lastUpdate:"2h ago Mona Ali"
            
        },
        {
            id: "CPN-006",
            name: "Eid Offer 100",
            code: "EID100",
            type: "Percentage",
            trigger: "Manual",
            priority: "High",
            fundingSource: "Provider",
            risk: "Low",
            validity: "Mar10 - May 31, 2025",
            budgetUsage: 80,
            redemptions: 405,
               status:{
                name: "Scheduled",
                color:"#7E1BAD",
                bgColor: "#F6E9FC",
                note:"This coupon is scheduled to be activated on the start date.",
                start_date:"10 Jul 2026 - 12:00 am",
                end_date:"20 Jul 2026 - 11:59 am",
                status_date: null,
                edit_date: null,
                status_by:"System Scheduler",
                activate: null
                
            },
    lastUpdate:"2h ago Mona Ali"
        },
    ];
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
 const [menuState, setMenuState] = useState({
    anchorEl: null,
    row: null,
  });

  const handleClose = () => {
    setMenuState({
      anchorEl: null,
      row: null,
    });
  };

  const handleClick = (event, row) => {
    setMenuState({
      anchorEl: event.currentTarget,
      row: row,
    });
    // setRequestId(row.id);
  };

    const handleActivate = () => {
        console.log(selectedRows);
    };
    const handleReset = () => {
        setSelectedRows([])


    };

    const handlePause = () => {
        console.log(selectedRows);
    };

    const handleDelete = () => {
        console.log(selectedRows);
    };
    const data = [
        { date: "Apr 22", value: 3500 },
        { date: "Apr 29", value: 11300 },
        { date: "May 06", value: 5300 },
        { date: "May 13", value: 6000 },
        { date: "May 20", value: 2300 }

    ];
    const donutData = [
        { name: "Active", value: 148, color: "#3FBEAC" },
        { name: "Scheduled", value: 28, color: "#7E1BAD" },
        { name: "Draft", value: 37, color: "#8CB369" },
        { name: "Expired", value: 46, color: "#696969" },
        { name: "Disabled", value: 12, color: "#A80101" }
    ];

    const total = donutData.reduce(
        (sum, item) => sum + item.value,
        0
    );



    return (
        <div className='m-4'>
            <div className="d-flex justify-content-between align-items-center">
                <div className="">
                    <h5 className="fw-bold">Coupons</h5>
                    <p className="main-text-color label-size">Manage, monitor and analyze all coupons across the platform.</p>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <button className='btn btn-dark px-2'>
                        <AddIcon sx={{ mr: 1, fontSize: 20 }} />
                        Create Coupon
                    </button>

                    <button
                        className='btn btn-light'
                    >
                        <FileDownloadOutlinedIcon sx={{ color: "#535353", mr: 1, fontSize: 20 }} />

                        Export
                    </button>
                </div>
            </div>
            <div className="my-1 row border-bottom py-3">
                {stats.map((item) =>
                    <>
                        <div className="col-md-3 d-flex align-items-center ">
                            <div className="border shadow rounded-4 px-3 py-3 w-100 my-2">
                                <div className='d-flex gap-2 align-items-center'>
                                    <img src={statusIcon} alt="status" />
                                    <h6 className='m-0'>
                                        {item.title}
                                    </h6>
                                </div>

                                <h5 className='mt-1 fw-bold'>
                                    {item.value}
                                </h5>

                                <h6 className='main-text-color label-van'>
                                    {item.subtitle}
                                </h6>
                            </div>

                        </div>
                    </>

                )}
            </div>
            <div className='row my-4 border-bottom d-flex align-items-end'>
                <div className="col-md-3 col-12">
                    {/* Search */}
                    <TextField
                        placeholder="Search by coupon name, code, campaign..."
                        size="small"
                        sx={{
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon sx={{ color: "#888", fontSize: 20 }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className="col-md-9 col-12 row d-flex justify-content-end">
                    <div className='col-md-2'>
                        <label id='' className='main-text-color label-size my-1'>
                            Status
                        </label>

                        <FormControl size="small" sx={{ width: "100%" }}>
                            <Select
                                defaultValue="all"
                                IconComponent={KeyboardArrowDownIcon}
                                sx={{ borderRadius: "8px" }}

                            >
                                <MenuItem className="p-2 mt-1" value="all">All Status</MenuItem>
                                <MenuItem className="p-2" value="active">Active</MenuItem>
                                <MenuItem className="p-2" value="inactive">Inactive</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    <div className='col-md-2'>
                        <label id='' className='main-text-color label-size my-1'>
                            Type
                        </label>


                        <FormControl size="small" sx={{ width: "100%" }}>
                            <Select
                                defaultValue="all"
                                IconComponent={KeyboardArrowDownIcon}
                                sx={{ borderRadius: "8px" }}
                            >
                                <MenuItem className="p-2 mt-1" value="all">All Types</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    <div className='col-md-2'>
                        <label id='' className='main-text-color label-size my-1'>
                            Funding Source
                        </label>

                        <FormControl size="small" sx={{ width: "100%" }}>
                            <Select
                                defaultValue="all"
                                IconComponent={KeyboardArrowDownIcon}
                                sx={{ borderRadius: "8px" }}
                            >
                                <MenuItem className="p-2 mt-1" value="all">All Sources</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    <div className='col-md-2 col-12'>
                        <label id='' className='main-text-color label-size my-1'>
                            Scope
                        </label>

                        <FormControl size="small" sx={{ width: "100%" }}>
                            <Select
                                defaultValue="all"
                                IconComponent={KeyboardArrowDownIcon}
                                sx={{ borderRadius: "8px" }}
                            >
                                <MenuItem className="p-2 mt-1" value="all">All Scopes</MenuItem>
                            </Select>
                        </FormControl>
                    </div>

                    <div className='col-md-3 col-12'>
                        <label id='' className='main-text-color label-size'>
                            Date Range
                        </label>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DatePicker"]}>
                                <DatePicker
                                    sx={{ width: "100%" }}
                                    className="m-0"
                                    format="DD,MM,YYYY"
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            placeholder: "Select Date",
                                        },
                                    }}
                                // value={expireDate}
                                // onChange={(date) => setExpireDate(date)}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                    </div>
                </div>


            </div>
            <Box className='custom-tab-style' sx={{ marginBlock: 1, borderColor: 'divider' }}>
                <Tabs
                    value={0}

                    // onChange={(e, v) => setTab(v)}
                    sx={{ borderBottom: " 1px solid #D8D8D8", }}
                    TabIndicatorProps={{
                        sx: {
                            backgroundColor: "#3FBEAC",
                            height: "3px",
                            textTransform: "capitalize"



                        },
                    }}

                >
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}

                        label={<div className='d-flex gap-1 align-items-center'><h6 className="m-0 label-size">All Coupons</h6>

                            <Chip sx={{ color: "#fff", bgcolor: "#3FBEAC" }} label={"256"} />

                        </div>} />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">Active</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"148"} />

                        </div>}
                    />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">Scheduled</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"28"} />

                        </div>} />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">Draft</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"34"} />

                        </div>} />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">Expird</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"46"} />

                        </div>} />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">Disabled</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"12"} />

                        </div>} />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">Needs Approval</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"12"} />

                        </div>} />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">High Risk</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"5"} />

                        </div>} />
                    <Tab sx={{ textTransform: "capitalize", fontSize: "15px" }}
                        label={<div className='d-flex gap-1 align-items-center'>
                            <h6 className="m-0 label-size">Low Margin</h6>

                            <Chip sx={{ color: "#535353", bgcolor: "#E8E8E8" }} label={"4"} />

                        </div>} />
                </Tabs>
            </Box>
            <div className="my-2">

                <Paper
                    elevation={0}
                    sx={{
                        mb: 2,
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",

                    }}
                >
                    <Box>
                        <Typography fontSize={18} fontWeight={600}>All Coupons</Typography>
                    </Box>
                    {
                        selectedInfoRows.length > 0 && (
                            <Box sx={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                gap: 2
                            }}>
                                <Box display={"flex"} alignItems={"center"}>
                                    <Checkbox checked
                                        checkedIcon={
                                            <div
                                                style={{
                                                    width: 22,
                                                    height: 22,
                                                    borderRadius: 4,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",

                                                    backgroundColor: "#000"
                                                }}
                                            >
                                                <CheckIcon
                                                    style={{ color: "#fff", fontSize: 18 }}
                                                />
                                            </div>
                                        } size='small' />
                                    <Typography fontSize={14}>
                                        {selectedInfoRows.length} selected
                                    </Typography>
                                </Box>
                                <Box sx={{ borderInlineEnd: "2px solid #BCBCBC", p: 2 }} />
                                <Typography fontSize={14}>
                                    Bulk actions:
                                </Typography>
                                <Stack direction="row" spacing={1}>
                                    <button
                                        style={{ border: "1px solid #04B22E33", fontSize: "14px" }}
                                        className='btn px-3 d-flex align-items-center gap-1'

                                        onClick={handleActivate}
                                    >
                                        <PlayArrowOutlined sx={{ color: "#04B22E" }} />
                                        Activate
                                    </button>

                                    <button
                                        style={{ border: "1px solid #FEB91E4D", fontSize: "14px" }}
                                        className='btn px-3 d-flex align-items-center gap-1'

                                        onClick={handleActivate}
                                    >
                                        <PauseOutlined sx={{ color: "#FEB91E" }} />
                                        Pause
                                    </button>
                                    <button
                                        style={{ border: "1px solid #A8010133", fontSize: "14px" }}
                                        className='btn px-3 d-flex align-items-center gap-1'

                                        onClick={handleActivate}
                                    >
                                        <DeleteOutline sx={{ color: "#A80101" }} />
                                        Delete
                                    </button>
                                </Stack>
                                <Box sx={{ borderInlineEnd: "2px solid #BCBCBC", p: 2 }} />
                                <button
                                    style={{ color: "#535353", fontSize: "14px" }}
                                    className='btn btn-outline-light px-3 d-flex align-items-center gap-1'

                                // onClick={handleActivate}
                                >
                                    <CloseOutlined sx={{ color: "#535353" }} />
                                    Clear Selection
                                </button>
                            </Box>
                        )
                    }
                </Paper>

                <div className="data-grid-small">

                    <Paper
                        sx={{
                            width: "100%",

                            "& .MuiDataGrid-cell": {
                                fontSize: "13px",
                            },

                            "& .MuiDataGrid-columnHeaderTitle": {
                                fontSize: "14px",
                                fontWeight: 600,
                            },

                        }}
                    >
                        <DataGrid

                            rows={rows}
                            columns={columns}
                            initialState={{ pagination: { paginationModel } }}
                            pageSizeOptions={[5, 10, 20, 50]}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelection) => {
                                setSelectedRows(newSelection);
                                setSelectedInfoRows(newSelection);
                            }}
                            sx={{ overflow: "hidden" }}
                            slotProps={{

                                pagination: {
                                    sx: {
                                        justifyContent: "end",
                                        display: "flex",
                                        alignItems: "center",

                                    },
                                },
                            }}
                        />
                    </Paper>

                    <StatusInfoPopover
                        anchorEl={anchorEl}
                        onClose={handleStatusInfoClose}
                        data={selectedStatusData}
                    />

                </div>



            </div>
            <div className="row my-4">
                <div className="col-md-8 col-12">
                    <div className=" py-3 px-2 border rounded-3">
                        <h6 className="label-size fw-semibold">Business Impact Overview</h6>
                        <div className="my-3 row ">
                            {impact.map((item) =>
                                <>
                                    <div className="col-md-3 d-flex align-items-center ">
                                        <div className="border rounded-4 px-3 py-3 w-100">
                                            <div className='d-flex gap-2 align-items-center'>
                                                <Chip sx={{ bgcolor: "#000", color: "#fff", fontSize: 18 }} label={item.icon} />
                                                <h6 className='m-0 label-size'>
                                                    {item.title}
                                                </h6>
                                            </div>

                                            <h5 className='mt-1 fw-bold'>
                                                {item.value}
                                            </h5>

                                            <h6 className='main-text-color label-van'>
                                                {item.subtitle}
                                            </h6>
                                        </div>

                                    </div>
                                </>

                            )}
                        </div>
                    </div>
                    <div className="my-2 py-3 px-2 border rounded-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className="m-0 label-size">Usage Trend <span className='main-text-color'>( Last 30 Days)</span></h6>
                            <FormControl size="small">
                                <Select
                                    defaultValue="all"
                                    IconComponent={KeyboardArrowDownIcon}
                                    sx={{ borderRadius: "8px" }}

                                >
                                    <MenuItem className="p-2 mt-1" value="all">Last 30 Days</MenuItem>
                                    <MenuItem className="p-2" value="active">Last 20 Days</MenuItem>
                                    <MenuItem className="p-2" value="inactive">Last 10 Days</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <Box sx={{ width: "100%", height: 350 }}>
                            <ResponsiveContainer>
                                <AreaChart data={data}>
                                    <defs>
                                        <linearGradient
                                            id="colorValue"
                                            x1="0"
                                            y1="0"
                                            x2="0"
                                            y2="1"
                                        >
                                            <stop
                                                offset="5%"
                                                stopColor="#3FBEAC"
                                                stopOpacity={0.25}
                                            />
                                            <stop
                                                offset="95%"
                                                stopColor="#34B3F1"
                                                stopOpacity={0}
                                            />
                                        </linearGradient>
                                    </defs>

                                    <CartesianGrid
                                        strokeDasharray="3 3"
                                        vertical={false}
                                    />

                                    <XAxis dataKey="date" />

                                    <YAxis />

                                    <Tooltip />

                                    <Area
                                        type="monotone"
                                        dataKey="value"
                                        stroke="#46C1B6"
                                        strokeWidth={4}
                                        fill="url(#colorValue)"
                                    />
                                </AreaChart>
                            </ResponsiveContainer>
                        </Box>
                    </div>
                    <div className="row my-4">
                        <div  className="col-md-6 col-12">
                            <div style={{height:300}} className="border rounded-3 w-100 py-2 px-3 ">
                                <div className="border-bottom pb-3 pt-2">
                                    <h6 className="fw-semibold">Coupon Health</h6>
                                </div>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    <Box sx={{ width: 180, height: 180 }}>
                                        <ResponsiveContainer>
                                            <PieChart>
                                                <Pie
                                                    data={donutData}
                                                    dataKey="value"
                                                    innerRadius={57}
                                                    outerRadius={80}
                                                    startAngle={90}
                                                    endAngle={-270}
                                                >
                                                    {donutData.map((item) => (
                                                        <Cell
                                                            key={item.name}
                                                            fill={item.color}
                                                        />
                                                    ))}
                                                </Pie>

                                                <text
                                                    x="50%"
                                                    y="50%"
                                                    textAnchor="middle"
                                                    fontSize="30"
                                                    fontWeight="700"
                                                >
                                                    {total}
                                                </text>

                                                <text
                                                    x="50%"
                                                    y="60%"
                                                    textAnchor="middle"
                                                    fontSize="14"
                                                >
                                                    Total
                                                </text>
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </Box>

                                    <Box>
                                        {donutData.map((item) => (
                                            <Box
                                                key={item.name}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                    my: 1
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 10,
                                                        height: 10,
                                                        borderRadius: "50%",
                                                        bgcolor: item.color
                                                    }}
                                                />

                                                <Typography fontSize={14} my={.5}>
                                                    {item.value} {item.name} (
                                                    {(
                                                        (item.value / total) *
                                                        100
                                                    ).toFixed(1)}
                                                    %)
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>

                            </div>
                        </div>
                        <div  className="col-md-6 col-12">
                            <div className='w-100 h-100 border rounded-3 py-2 px-3'>
                                <div className="border-bottom pb-3 pt-2 d-flex justify-content-between align-items-center">
                                    <h6 className="fw-semibold">Near Budget Limit</h6>
                                    <Link sx={{ color: "#159D89", textDecorationLine: "none" }}>View all <ArrowForward fontSize='14px' /></Link>
                                </div>

                                <List>
                                    <ListItem sx={{ borderBottom: "1px solid #E8E8E8"}}>
                                        <div className='row w-100 my-2 py-2 align-items-center'>
                                            <div className='col-md-5 col-12 d-flex justify-content-start'>
                                                <Typography fontSize={14}>Flash Sale 50%</Typography>
                                            </div>
                                            <div className="col-md-5 col-12 d-flex justify-content-center">
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={89}
                                                    sx={{
                                                        height: 8,
                                                        borderRadius: 4,
                                                        backgroundColor: "#DADADA",
                                                        width: "100%",
                                                        "& .MuiLinearProgress-bar": {
                                                            backgroundColor: "#A80101",
                                                            borderRadius: 10,
                                                        },
                                                    }}
                                                />

                                            </div>

                                            <div className="col-md-2 col-12 d-flex justify-content-end">
                                                <Typography fontSize={14}>89%</Typography>
                                            </div>

                                        </div>
                                    </ListItem>

                                    <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                        <div className='row w-100 my-2 py-2 align-items-center'>
                                            <div className="col-md-5 col-12 d-flex justify-content-start">
                                                <Typography fontSize={14}>VIP 30% Off</Typography>
                                            </div>
                                            <div className="col-md-5 col-12 d-flex justify-content-center">
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={90}
                                                    sx={{
                                                        height: 8,
                                                        borderRadius: 4,
                                                        backgroundColor: "#DADADA",
                                                        width: "100%",
                                                        "& .MuiLinearProgress-bar": {
                                                            backgroundColor: "#A80101",
                                                            borderRadius: 10,
                                                        },
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-2 col-12 d-flex justify-content-end">
                                                <Typography fontSize={14}>90%</Typography>
                                            </div>

                                        </div>
                                    </ListItem>

                                    <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                        <div className='row w-100 my-2 py-2 align-items-center'>
                                            <div className="col-md-5 col-12 d-flex justify-content-start">
                                                <Typography fontSize={14}>Battery Care 15</Typography>
                                            </div>
                                            <div className="col-md-5 col-12 d-flex justify-content-center">
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={67}
                                                    sx={{
                                                        height: 8,
                                                        borderRadius: 4,
                                                        backgroundColor: "#DADADA",
                                                        width: "100%",
                                                        "& .MuiLinearProgress-bar": {
                                                            backgroundColor: "#A80101",
                                                            borderRadius: 10,
                                                        },
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-2 col-12 d-flex justify-content-end">
                                                <Typography fontSize={14}>67%</Typography>
                                            </div>



                                        </div>
                                    </ListItem>
                                    <ListItem>
                                        <div className='row w-100 my-2 py-2 align-items-center'>
                                            <div className="col-md-5 col-12 d-flex justify-content-start">
                                                <Typography fontSize={14}>Flash-Sale 50%</Typography>
                                            </div>
                                            <div className="col-md-5 col-12 d-flex justify-content-center">
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={50}
                                                    sx={{
                                                        height: 8,
                                                        borderRadius: 4,
                                                        backgroundColor: "#DADADA",
                                                        width: "100%",

                                                        "& .MuiLinearProgress-bar": {
                                                            backgroundColor: "#A80101",
                                                            borderRadius: 10,
                                                        },
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-2 col-12 d-flex justify-content-end">
                                                <Typography fontSize={14}>50%</Typography>
                                            </div>



                                        </div>
                                    </ListItem>
                                </List>
                            </div>
                        </div>

                    </div>

                </div>
                <div className="col-md-4 col-12">
                    <div className='w-100 border rounded-3 py-2 px-3'>
                        <div className="border-bottom pb-3 pt-2 d-flex justify-content-between align-items-center">
                            <h6 className="fw-semibold">Most Abused Coupons</h6>
                            <Link sx={{ color: "#159D89", textDecorationLine: "none" }}>View all <ArrowForward fontSize='14px' /></Link>
                        </div>

                        <List>
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 30, height: 30, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <FaGift color='#3FBEAC' size={20} />

                                        </div>
                                        <Typography fontSize={14}>Welcome 20% OFF</Typography>

                                    </div>
                                    <div className="col-md-4 col-12 d-flex justify-content-center">
                                        <Typography fontSize={14} fontWeight={700}>580,000 EGP</Typography>

                                    </div>

                                    <div className="col-md-2 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14}>6.2x</Typography>
                                    </div>

                                </div>
                            </ListItem>
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 30, height: 30, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <IoMoonSharp color='#FEB91E' size={20} />

                                        </div>
                                        <Typography fontSize={14}>Ramadan Special 25</Typography>

                                    </div>
                                    <div className="col-md-4 col-12 d-flex justify-content-center">
                                        <Typography fontSize={14} fontWeight={700}>420,000 EGP</Typography>

                                    </div>

                                    <div className="col-md-2 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14}>5.1x</Typography>
                                    </div>

                                </div>
                            </ListItem>
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 30, height: 30, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <IoMoonSharp color='#FEB91E' size={20} />

                                        </div>
                                        <Typography fontSize={14}>Ramadan Special 25</Typography>

                                    </div>
                                    <div className="col-md-4 col-12 d-flex justify-content-center">
                                        <Typography fontSize={14} fontWeight={700}>420,000 EGP</Typography>

                                    </div>

                                    <div className="col-md-2 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14}>5.1x</Typography>
                                    </div>

                                </div>
                            </ListItem>

                            <ListItem >
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 30, height: 30, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <IoFlashSharp color='#A80101' size={20} />

                                        </div>
                                        <Typography fontSize={14}>Flash Sale 50%</Typography>

                                    </div>
                                    <div className="col-md-4 col-12 d-flex justify-content-center">
                                        <Typography fontSize={14} fontWeight={700}>320,000 EGP</Typography>

                                    </div>

                                    <div className="col-md-2 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14}>3.6x</Typography>
                                    </div>

                                </div>
                            </ListItem>


                        </List>
                    </div>
                 <div className="w-100 border rounded-3 py-2 px-3 my-4">
                        <div className="border-bottom pb-3 pt-2 d-flex justify-content-between align-items-center">
                            <h6 className="fw-semibold">Top Performing Coupons</h6>
                            <Link sx={{ color: "#159D89", textDecorationLine: "none" }}>View all <ArrowForward fontSize='14px' /></Link>
                        </div>

                        <List>
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 32, height: 32, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <RiOilFill color='#FEB91E' size={20} />

                                        </div>
                                        <Typography width={"100%"} fontSize={14}>Weekend Oil Coupon</Typography>

                                    </div>
                                   
                                    <div className="col-md-6 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14} color='#535353'>Usage rate 92%</Typography>
                                    </div>

                                </div>
                            </ListItem>
                      
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 32, height: 32, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <IoIosSunny color='#DA9907' size={18} />

                                        </div>
                                        <Typography width={"100%"} fontSize={14}>Summer Welcome</Typography>

                                    </div>
                                   
                                    <div className="col-md-6 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14} color='#535353'>Usage rate 72%</Typography>
                                    </div>

                                </div>
                            </ListItem>
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 32, height: 32, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <IoIosSunny color='#DA9907' size={20} />

                                        </div>
                                        <Typography width={"100%"} fontSize={14}>Summer Welcome</Typography>

                                    </div>
                                   
                                    <div className="col-md-6 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14} color='#535353'>Usage rate 72%</Typography>
                                    </div>

                                </div>
                            </ListItem>
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-2 py-1 align-items-center'>
                                    <div className='col-md-6 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 35, height: 32, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                            <FaCarBattery color='#FC6C4F' size={20} />

                                        </div>
                                        <Typography width={"100%"} fontSize={14}>Battery Flash</Typography>

                                    </div>
                                   
                                    <div className="col-md-6 col-12 d-flex justify-content-end">
                                        <Typography fontSize={14} color='#535353'>Usage rate 68%</Typography>
                                    </div>

                                </div>
                            </ListItem>
                      


                        </List>
                 </div>
                 <div className="w-100 border rounded-3 py-2 px-3 my-4">
                        <div className="border-bottom pb-3 pt-2 d-flex justify-content-between align-items-center">
                            <h6 className="fw-semibold">Recent Activity</h6>
                            <Link sx={{ color: "#159D89", textDecorationLine: "none" }}>View all <ArrowForward fontSize='14px' /></Link>
                        </div>

                        <List>
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-1 py-1 align-items-center'>
                                    <div className='col-md-9 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 35, height: 35, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                         <img className='w-100 h-100' src={agentimg} alt="" />
                                        </div>
                                        <Typography fontWeight={600} width={"100%"} fontSize={12}>Osama Ali <span className='main-text-color'>updated</span> Welcome 20% OFF</Typography>

                                    </div>
                                   
                                    <div className="col-md-3 col-12 d-flex justify-content-end">
                                        <Typography width={"100%"} fontSize={12} color='#535353'>20m ago</Typography>
                                    </div>

                                </div>
                            </ListItem>
                         
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-1 py-1 align-items-center'>
                                    <div className='col-md-9 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 35, height: 35, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                         <img className='w-100 h-100' src={agentimg} alt="" />
                                        </div>
                                        <Typography fontWeight={600} width={"100%"} fontSize={12}>Osama Ali <span className='main-text-color'>updated</span> Welcome 20% OFF</Typography>

                                    </div>
                                   
                                    <div className="col-md-3 col-12 d-flex justify-content-end">
                                        <Typography  width={"100%"} fontSize={12} color='#535353'>20m ago</Typography>
                                    </div>

                                </div>
                            </ListItem>
                         
                            <ListItem sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <div className='row w-100 my-1 py-1 align-items-center'>
                                    <div className='col-md-9 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 35, height: 35, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                         <img className='w-100 h-100' src={agentimg} alt="" />
                                        </div>
                                        <Typography fontWeight={600} width={"100%"} fontSize={12}>Osama Ali <span className='main-text-color'>updated</span> Welcome 20% OFF</Typography>

                                    </div>
                                   
                                    <div className="col-md-3 col-12 d-flex justify-content-end">
                                        <Typography width={"100%"} fontSize={12} color='#535353'>20m ago</Typography>
                                    </div>

                                </div>
                            </ListItem>
                         
                            <ListItem>
                                <div className='row w-100 my-1 py-1 align-items-center'>
                                    <div className='col-md-9 col-12 d-flex justify-content-start align-items-center gap-2'>
                                        <div
                                            style={{
                                                width: 35, height: 35, borderRadius: "50%", padding: 2, border: "1px solid #E8E8E8",
                                                display: "flex", justifyContent: "center", alignItems: "center"
                                            }}>
                                         <img className='w-100 h-100' src={agentimg} alt="" />
                                        </div>
                                        <Typography fontWeight={600} width={"100%"} fontSize={12}>Osama Ali <span className='main-text-color'>updated</span> Welcome 20% OFF</Typography>

                                    </div>
                                   
                                    <div className="col-md-3 col-12 d-flex justify-content-end">
                                        <Typography width={"100%"} fontSize={12} color='#535353'>20m ago</Typography>
                                    </div>

                                </div>
                            </ListItem>
                         
                      
                           
                      


                        </List>
                 </div>
                </div>
            </div>
        </div>
    )
}

export default IncentivesCoupons
